// import 'babel-polyfill';     // uncomment this if you want to use for...of, async/await
                                // or other things that require babel runtime
var $ = jQuery.noConflict();
// import Preloader from './modules/preloader';
import './modules/isMobile';
import './modules/ga';
import './modules/slider-main';
import './modules/last-work';
import './modules/portfolio-gallery';
import './modules/lightbox';
import './modules/dropdown';
import './modules/mobileMenu';
import AOS from './vendor/aos';


window.addEventListener('load', () => {
    // Preloader.hide();
    AOS.init();

    if( window.location.hash=="#gallery"){
      window.location.hash = "";
    }
 
});


// $( window ).resize(function() {
//   AOS.refresh();
// });


$(window).scroll(function() {
  if ($(document).scrollTop() > 50) {
    $('.navbar').addClass('shrink');
  } else {
    $('.navbar').removeClass('shrink');
  }
});

$(document).ready(function(){
	
	$('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		

  	$('.tab-content.current').fadeOut( function() {
			$('.tab-content').removeClass('current');
			$("#"+tab_id).fadeIn();
			$("#"+tab_id).addClass('current');
  	});
		
		
		$(this).addClass('current');
	
	})

  smoothScroll();



})


var smoothScroll = function() {
  $('a[href*=#]:not([href=#])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top-80
        }, 1000);
        return false;
      }
    }
  });
};
